import { Link, navigate } from "gatsby";
import moment from "moment";
import React, { Component, createRef } from "react";
import { Modal } from "react-bootstrap";
import {
  getCategories,
  getManufacturers,
  getTopManufacturers,
  getNotification,
  getRegions,
  updateNotification,
  getCart,
  getCount,
  logOut,
  unReadChatCount,
} from "../actions/memberAction";
import CommonHeader from "./common/commonHeader";
import Logo from "./common/logo";
import algoliasearch from "algoliasearch";
import NewDashboardSidebarMobile from "./dashboard/newDashboardSidebarMobile";
import MobileDropdown from "./dropdownMobile";
import MobileDropdown1 from "./dropDownMobileMain";

//css
import * as styles from "../include/css/css-components/header/Header.module.css";

import ChatIcon from "./common/chatIcon";
import { isMobile } from "react-device-detect";
import LoadingBar from "react-top-loading-bar";
import ScrollButton from "./common/scrollToTop/scrollToTop";

const client = algoliasearch(process.env.GATSBY_ALGOLIA_APP_ID, process.env.GATSBY_ALGOLIA_API_KEY);
const index = client.initIndex(process.env.GATSBY_ALGOLIA_LISTINGS_INDEX);

class Header extends Component {
  ref = createRef(null);
  dropDownRef = createRef(null);
  state = {
    dropDown: false,
    upcomingDropDown: false,
    upcomingDropDownMobile: false,
    regionDropDown: false,
    type: "",
    upcomingBidDropDown: {},
    notifications: [],
    modal: false,
    facets: {},
    showSearch: false,
    showMobileDropdown: false,
    showDashboardSidebarMobile: false,
    allManufacturers: [],
    queryData: "",
    data: {},
    showMobileFilter: false,
    showMobileFilter1: false,
    isCartEmpty: false,
    dashboardCount: {},
    unReadChatCount: "",
  };

  toggleDashboardSidebarModal = () => {
    this.setState({
      showDashboardSidebarMobile: !this.state.showDashboardSidebarMobile,
    });
  };

  detectClickoutside = (e) => {
    if (this.state.showSearch && this.dropDownRef.current && !this.dropDownRef.current.contains(e.target)) {
      this.setState({ showSearch: false });
    }
  };

  componentDidUpdate = (prevProps, prevState) => {
    if (this.state.showSearch && this.state.showSearch !== prevState.showSearch) {
      document.addEventListener("click", this.detectClickoutside);
    }
    if (this.props?.updateCount && !prevProps?.updateCount) {
      this.getUnreadChatCount();
      this.props?.setUpdateCount(false);
    }
  };

  componentWillUnmount = () => {
    document.removeEventListener("click", this.detectClickoutside);
  };

  toggleModal = () => {
    this.setState({
      modal: !this.state.modal,
    });
  };
  toggleMobileDropdownModal = (e) => {
    if (e) e.preventDefault();
    this.setState({
      showMobileDropdown: !this.state.showMobileDropdown,
    });
  };

  readNotification = (id) => {
    // props.refStart()
    updateNotification(id, () => {
      //props.refStop()
      const nt = this.state.notifications;
      const newNotification = nt.find((nt) => nt.id !== id);
      newNotification.viewed = true;
      const indexNo = nt.indexOf(newNotification);
      nt[indexNo] = newNotification;
      this.setState({ notifications: nt });
      navigate(`/listings/listing_detail.cfm/aucid/${newNotification.auction_id}`);
    });
  };

  toggleMobileFilter = (e) => {
    if (e) e.preventDefault();
    this.setState({ showMobileFilter: !this.state.showMobileFilter });
  };

  toggleMobileFilter1 = (e) => {
    if (e) e.preventDefault();
    this.setState({ showMobileFilter1: !this.state.showMobileFilter1 });
  };

  getUnreadChatCount = () => {
    unReadChatCount((res) => {
      this.setState({ unReadChatCount: res.data?.data });
    });
  };

  componentDidMount() {
    if (typeof window !== "undefined" && localStorage.getItem("member")) {
      getCount((res) => {
        if (res && res.status == 200) {
          this.setState({ dashboardCount: res.data });
        }
      });
      this.getUnreadChatCount();
      if (!this.props?.ischatPage) {
        const chatCount = setInterval(() => {
          this.getUnreadChatCount();
        }, 5000 * 60);
        return () => clearInterval(chatCount);
      }
    }

    const a = { ...this.state.data };
    getCategories({}, (res) => {
      if (res && res.status === 200) {
        a.allCategoryListHome = res.data;
      }
    });

    getRegions((res) => {
      if (res && res.status === 200) {
        a.allRegionsHome = res.data;
      }
    });

    getTopManufacturers((res) => {
      if (res && res.status === 200) {
        a.Manufacturer = res.data;
        this.setState({ allManufacturers: res.data });
      }
    });

    getManufacturers((res) => {
      if (res && res.status === 200) {
        a.allTopManufacturer = res.data;
        this.setState({ allManufacturers: res.data });
      }
    });

    this.setState({ data: a });

    getNotification(2, async (data) => {
      if (data.status === 200) {
        const nt = [];
        for (let index = 0; index < data.data.data.length; index++) {
          const element = data.data.data[index];
          const htmlString = element.subject;
          const plainText = htmlString.replace(/<[^>]+>/g, "$");
          element.data = plainText.split("$").filter((eds) => eds !== "" && eds !== "[datetext]");
          nt.push(element);
        }
        this.setState({ notifications: nt });
      }
    });
  }
  toggleUpcomingDropDown = () => {
    this.setState({
      upcomingDropDown: !this.state.upcomingDropDown,
      showSearch: false,
    });
  };
  toggleUpcomingDropDownMobile = () => {
    this.setState({
      upcomingDropDownMobile: !this.state.upcomingDropDownMobile,
    });
  };
  hideDropdown = () => this.setState({ dropDown: false, regionDropDown: false });

  toggleDropdown = (e, type) => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    e.preventDefault();
    if (type === this.state.type) {
      this.setState({
        dropDown: !this.state.dropDown,
        type,
        regionDropDown: false,
      });
    } else {
      this.setState({ dropDown: true, type, regionDropDown: false });
    }
  };

  toggleDropdownRegion = (e) => {
    window.scrollTo({ top: 0, behavior: "smooth" });

    e.preventDefault();
    this.setState({
      dropDown: false,
      regionDropDown: !this.state.regionDropDown,
    });
  };

  onChangeInput = async (e) => {
    if (this.props.page == "search") {
      this.props.setQueryData(e.target.value);
      if (!this.props.searchPage) {
        const records = await index.search(e.target.value, {
          facets: ["categories.lvl0", "make", "region"],
          hitsPerPage: 1,
        });

        this.setState({ facets: records.facets });
        if (records.facets && Object.keys(records.facets).length > 0) {
          this.setState({ showSearch: true, upcomingDropDown: false });
        } else {
          this.setState({ showSearch: false });
        }
      }
    } else {
      this.setState({ queryData: e.target.value });
      if (!this.props.searchPage) {
        const records = await index.search(e.target.value, {
          facets: ["categories.lvl0", "make", "region"],
          hitsPerPage: 1,
        });

        this.setState({ facets: records.facets });
        if (records.facets && this.props.page !== "search") {
          this.setState({ showSearch: true, upcomingDropDown: false });
        }
        //  else {
        //   this.setState({ showSearch: false });
        // }
      }
    }
  };

  onLogOut = () => {
    this.ref?.current?.continuousStart();
    logOut((res) => {
      if (res && res.status == 200) {
        this.ref?.current?.complete();
        if (typeof window !== "undefined") {
          window.localStorage.removeItem("token");
          window.localStorage.removeItem("member");
          window.localStorage.removeItem("buyerInspectionClosed");
          window.localStorage.removeItem("buyerInspectionDate");
          window.localStorage.removeItem("mimictoken");
          window.localStorage.removeItem("mimicmember");
          window.location.href = "/";
        }
      } else {
        this.ref?.current?.complete();
        if (typeof window !== "undefined") {
          window.localStorage.removeItem("token");
          window.localStorage.removeItem("member");
          window.localStorage.removeItem("buyerInspectionClosed");
          window.localStorage.removeItem("buyerInspectionDate");
          window.localStorage.removeItem("mimictoken");
          window.localStorage.removeItem("mimicmember");
          window.location.href = "/";
        }
      }
    });
  };

  render() {
    const {
      crumbs,
      pageTittle,
      contentOverview,
      queryString,
      numberOfRecord,
      // queryData,
      setGridView,
      gridView,
    } = this.props;

    const urlLocation = typeof window !== "undefined" && window?.location?.href;

    return (
      <React.Fragment>
        <LoadingBar color="#47ad1d" ref={this.ref} />
        <header id="header">
          <CommonHeader
            toggleModal={this.toggleModal}
            isCartEmpty={this.state.isCartEmpty}
            dashboardCount={this.state.dashboardCount}
            unReadChatCount={this.state.unReadChatCount}
            notshowncnda={this.props.notshowncnda}
          />
          <div className={`${styles.headerMainContainer} header-main-container`}>
            <nav className={`${styles.navbar} navbar navbar-expand-xl ${styles.navbarExpandXl}`}>
              <div className="container-fluid">
                <div className={`${styles.navInside} nav-inside position-relative flex-wrap d-flex align-items-center`}>
                  <Logo />
                  <button
                    className={`${styles.navIcon} nav-icon`}
                    type="button"
                    data-bs-toggle="modal"
                    data-bs-target="#categoriesCollapse"
                    onClick={this.toggleMobileFilter}
                  >
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                  </button>
                  <div className={` navbar-collapse flex-grow-0 d-none d-md-block`}>
                    <div className={`${styles.navbarInside} navbar-inside ml-auto navbar-md-header`}>
                      <ul className={`${styles.navbarNav} navbar-nav flex-md-row`}>
                        <li className={`${styles.navItem} nav-item`}>
                          <Link className={`${styles.navLink} nav-link`} to="/categories">
                            Categories
                          </Link>
                        </li>
                        <li className={`${styles.navItem} nav-item`}>
                          <Link className={`${styles.navLink} nav-link`} to="/manufacturers">
                            Manufacturers
                          </Link>
                        </li>
                        <li className={`${styles.navItem} nav-item`}>
                          <Link className={`${styles.navLink} nav-link`} to="/regions">
                            Regions
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <ul className={`${styles.headerNavList} header-nav-list ms-auto d-flex align-items-center d-xl-none`}>
                    {typeof window !== "undefined" && (
                      <>
                        {" "}
                        {window.localStorage.getItem("token") ? (
                          <>
                            {localStorage.getItem("member") &&
                              JSON.parse(localStorage.getItem("member")).sec_list != 100103 && (
                                <>
                                  {window.location.pathname === "/chats" || window.location.pathname === "/chats/" ? (
                                    <li class={`${styles.htcNavItem}`}>
                                      <a
                                        href="javascript:void(0)"
                                        class={`${styles.htcNavLink} htc-nav-link`}
                                        data-bs-toggle="modal"
                                        data-bs-target="#chatCollapse"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          //this.setState({ chatNotification: false });
                                          navigate("/chats");
                                        }}
                                      >
                                        <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <path
                                            d="M17.5 9.58336C17.5029 10.6832 17.2459 11.7683 16.75 12.75C16.162 13.9265 15.2581 14.916 14.1395 15.6078C13.021 16.2995 11.7319 16.6662 10.4167 16.6667C9.31678 16.6696 8.23176 16.4126 7.25 15.9167L2.5 17.5L4.08333 12.75C3.58744 11.7683 3.33047 10.6832 3.33333 9.58336C3.33384 8.26815 3.70051 6.97907 4.39227 5.86048C5.08402 4.7419 6.07355 3.838 7.25 3.25002C8.23176 2.75413 9.31678 2.49716 10.4167 2.50002H10.8333C12.5703 2.59585 14.2109 3.32899 15.4409 4.55907C16.671 5.78915 17.4042 7.42973 17.5 9.16669V9.58336Z"
                                            stroke-width="1.5"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                          ></path>
                                        </svg>
                                        {this.state.unReadChatCount > 0 ? (
                                          <span class="chats-numbers">{this.state.unReadChatCount}</span>
                                        ) : (
                                          ""
                                        )}
                                      </a>
                                    </li>
                                  ) : (
                                    <ChatIcon isMobile={true} unReadChatCount={this.state.unReadChatCount} />
                                  )}
                                </>
                              )}
                            <li class="htc-nav-item ">
                              {
                                <a
                                  href="javascript:void(0)"
                                  class="htc-nav-link add-to-cart"
                                  data-bs-toggle="modal"
                                  data-bs-target="#chatCollapse"
                                  onClick={(e) => {
                                    e.preventDefault();

                                    navigate("/my-account/cart");
                                  }}
                                >
                                  <svg
                                    width="20"
                                    height="20"
                                    viewBox="0 0 20 20"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <g clip-path="url(#clip0_5571_58128)">
                                      <path
                                        d="M7.50001 18.3334C7.96024 18.3334 8.33334 17.9603 8.33334 17.5C8.33334 17.0398 7.96024 16.6667 7.50001 16.6667C7.03977 16.6667 6.66667 17.0398 6.66667 17.5C6.66667 17.9603 7.03977 18.3334 7.50001 18.3334Z"
                                        stroke="black"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                      <path
                                        d="M16.6667 18.3334C17.1269 18.3334 17.5 17.9603 17.5 17.5C17.5 17.0398 17.1269 16.6667 16.6667 16.6667C16.2064 16.6667 15.8333 17.0398 15.8333 17.5C15.8333 17.9603 16.2064 18.3334 16.6667 18.3334Z"
                                        stroke="black"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                      <path
                                        d="M0.833344 0.833313H4.16668L6.40001 11.9916C6.47621 12.3753 6.68493 12.7199 6.98963 12.9652C7.29433 13.2105 7.67559 13.3408 8.06668 13.3333H16.1667C16.5578 13.3408 16.939 13.2105 17.2437 12.9652C17.5484 12.7199 17.7571 12.3753 17.8333 11.9916L19.1667 4.99998H5.00001"
                                        stroke="black"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                    </g>
                                    <defs>
                                      <clipPath id="clip0_5571_58128">
                                        <rect width="20" height="20" fill="white" />
                                      </clipPath>
                                    </defs>
                                  </svg>
                                  {this.state?.dashboardCount?.watchListCount > 0 ? (
                                    <span class="cart-numbers">{this.state?.dashboardCount?.watchListCount}</span>
                                  ) : (
                                    ""
                                  )}
                                </a>
                              }
                            </li>

                            <li className={`${styles.hnlItem} hnl-item`} style={{ marginLeft: "10px" }}>
                              <a
                                href="javascript:void(0)"
                                className={` hnl-link my-account-text ${styles.myAccountText}`}
                                data-bs-toggle="modal"
                                data-bs-target="#profileCollapse"
                                onClick={(e) => {
                                  e.preventDefault();
                                  if (this.props.myaccount) {
                                    this.setState({
                                      showDashboardSidebarMobile: true,
                                    });
                                  } else {
                                    navigate(
                                      typeof window !== "undefined" && window.localStorage.getItem("token")
                                        ? "/my-account/dashboard"
                                        : "/members/login",
                                    );
                                  }
                                }}
                              >
                                <svg
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21"
                                    stroke="black"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                  <path
                                    d="M12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11Z"
                                    stroke="black"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                </svg>
                                {typeof window !== "undefined" && window.localStorage.getItem("token") ? "" : "Login"}
                              </a>
                            </li>
                            <li>
                              {typeof window !== "undefined" && window.localStorage.getItem("token") ? (
                                <Link
                                  to="/members/post-listing"
                                  className={`${styles.headerBtn}  header-btn d-none d-md-block ms-3`}
                                >
                                  <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                      d="M10.0002 4.16669V15.8334"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                    <path
                                      d="M4.16687 10H15.8335"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                  </svg>
                                  Post a Listing
                                </Link>
                              ) : (
                                <a
                                  href="#"
                                  className={`${styles.headerBtn} header-btn d-none d-md-block ms-3`}
                                  onClick={(e) => {
                                    e.preventDefault();
                                    typeof window !== "undefined" &&
                                      window.localStorage.setItem("redirectUrl", "/members/post-listing");
                                    navigate("/members/login");
                                  }}
                                >
                                  <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                      d="M10.0002 4.16669V15.8334"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                    <path
                                      d="M4.16687 10H15.8335"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                  </svg>
                                  Post a Listing
                                </a>
                              )}
                            </li>
                          </>
                        ) : (
                          <li className={`${styles.hnlItem} hnl-item`}>
                            <a
                              href="javascript:void(0)"
                              className={` hnl-link my-account-text ${styles.myAccountText}`}
                              data-bs-toggle="modal"
                              data-bs-target="#profileCollapse"
                              onClick={(e) => {
                                e.preventDefault();
                                typeof window !== "undefined" &&
                                  window.localStorage.setItem("redirectUrl", urlLocation);
                                navigate(
                                  typeof window !== "undefined" && window.localStorage.getItem("token")
                                    ? "/my-account/dashboard"
                                    : "/members/login",
                                );
                              }}
                            >
                              <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21"
                                  stroke="black"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11Z"
                                  stroke="black"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </svg>
                              {typeof window !== "undefined" && window.localStorage.getItem("token")
                                ? "My Account"
                                : "Login"}
                            </a>
                          </li>
                        )}
                      </>
                    )}
                  </ul>
                  <div className={`${styles.headerRight} header-right d-flex align-items-center flex-grow-1`}>
                    <div className={` htc-nav  ms-auto d-none d-xl-block`}>
                      {typeof window !== "undefined" && (
                        <>
                          {localStorage.getItem("token") ? (
                            <ul
                              className={`${styles.htcNavList} htc-nav-list text-capitalize d-flex align-items-center`}
                            >
                              <li className={`${styles.htcNavItem} htc-nav-item`}>
                                <a
                                  href="javascript:void(0)"
                                  className={`${styles.htcNavLink} htc-nav-link`}
                                  data-bs-toggle="modal"
                                  data-bs-target="#notificationCollapse"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    navigate("/");
                                  }}
                                >
                                  <svg
                                    className={`${styles.htcNavLink} htc-nav-link`}
                                    width="20"
                                    height="20"
                                    viewBox="0 0 20 20"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M2.5 7.49996L10 1.66663L17.5 7.49996V16.6666C17.5 17.1087 17.3244 17.5326 17.0118 17.8451C16.6993 18.1577 16.2754 18.3333 15.8333 18.3333H4.16667C3.72464 18.3333 3.30072 18.1577 2.98816 17.8451C2.67559 17.5326 2.5 17.1087 2.5 16.6666V7.49996Z"
                                      stroke="black"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                    <path
                                      d="M7.5 18.3333V10H12.5V18.3333"
                                      stroke="black"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                  </svg>
                                  Home
                                </a>
                              </li>

                              <li className={`${styles.htcNavItem} htc-nav-item`}>
                                <a
                                  href="javascript:void(0)"
                                  className={`${styles.htcNavLink} htc-nav-link`}
                                  data-bs-toggle="modal"
                                  data-bs-target="#profileCollapse"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    navigate("/my-account/dashboard");
                                  }}
                                >
                                  <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                      d="M16.6667 17.5V15.8333C16.6667 14.9493 16.3155 14.1014 15.6904 13.4763C15.0653 12.8512 14.2174 12.5 13.3334 12.5H6.66671C5.78265 12.5 4.93481 12.8512 4.30968 13.4763C3.68456 14.1014 3.33337 14.9493 3.33337 15.8333V17.5"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                    <path
                                      d="M9.99996 9.16667C11.8409 9.16667 13.3333 7.67428 13.3333 5.83333C13.3333 3.99238 11.8409 2.5 9.99996 2.5C8.15901 2.5 6.66663 3.99238 6.66663 5.83333C6.66663 7.67428 8.15901 9.16667 9.99996 9.16667Z"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                  </svg>
                                  My Account
                                </a>
                              </li>
                              <li className={`${styles.htcNavItem} htc-nav-item`}>
                                <a
                                  href="javascript:void(0)"
                                  className={`${styles.htcNavLink} htc-nav-link`}
                                  onClick={(es) => {
                                    es.preventDefault();
                                    this.onLogOut();
                                  }}
                                >
                                  <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                      d="M12.5 2.5H15.8333C16.2754 2.5 16.6993 2.67559 17.0118 2.98816C17.3244 3.30072 17.5 3.72464 17.5 4.16667V15.8333C17.5 16.2754 17.3244 16.6993 17.0118 17.0118C16.6993 17.3244 16.2754 17.5 15.8333 17.5H12.5"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                    <path
                                      d="M8.33337 14.1666L12.5 9.99998L8.33337 5.83331"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                    <path
                                      d="M12.5 10H2.5"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                  </svg>
                                  Logout
                                </a>
                              </li>
                            </ul>
                          ) : (
                            <ul
                              className={`${styles.htcNavList} htc-nav-list text-capitalize d-flex align-items-center`}
                            >
                              <li className={`${styles.htcNavItem} htc-nav-item`}>
                                <a
                                  href="javascript:void(0)"
                                  className={`${styles.htcNavLink} htc-nav-link`}
                                  data-bs-toggle="modal"
                                  data-bs-target="#notificationCollapse"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    navigate("/");
                                  }}
                                >
                                  <svg
                                    className={`${styles.htcNavLink} htc-nav-link`}
                                    width="20"
                                    height="20"
                                    viewBox="0 0 20 20"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M2.5 7.49996L10 1.66663L17.5 7.49996V16.6666C17.5 17.1087 17.3244 17.5326 17.0118 17.8451C16.6993 18.1577 16.2754 18.3333 15.8333 18.3333H4.16667C3.72464 18.3333 3.30072 18.1577 2.98816 17.8451C2.67559 17.5326 2.5 17.1087 2.5 16.6666V7.49996Z"
                                      stroke="black"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                    <path
                                      d="M7.5 18.3333V10H12.5V18.3333"
                                      stroke="black"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                  </svg>
                                  Home
                                </a>
                              </li>
                              <li className={`${styles.htcNavItem} htc-nav-item`}>
                                <a
                                  href="/members/register"
                                  className={`${styles.htcNavLink} htc-nav-link`}
                                  data-bs-toggle="modal"
                                  data-bs-target="#profileCollapse"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    navigate("/members/register");
                                  }}
                                >
                                  <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                      d="M16.6667 17.5V15.8333C16.6667 14.9493 16.3155 14.1014 15.6904 13.4763C15.0653 12.8512 14.2174 12.5 13.3334 12.5H6.66671C5.78265 12.5 4.93481 12.8512 4.30968 13.4763C3.68456 14.1014 3.33337 14.9493 3.33337 15.8333V17.5"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                    <path
                                      d="M9.99996 9.16667C11.8409 9.16667 13.3333 7.67428 13.3333 5.83333C13.3333 3.99238 11.8409 2.5 9.99996 2.5C8.15901 2.5 6.66663 3.99238 6.66663 5.83333C6.66663 7.67428 8.15901 9.16667 9.99996 9.16667Z"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                  </svg>
                                  Signup
                                </a>
                              </li>
                              <li className={`${styles.htcNavItem} htc-nav-item`}>
                                <a
                                  href="javascript:void(0)"
                                  className={`${styles.htcNavLink} htc-nav-link`}
                                  onClick={(es) => {
                                    es.preventDefault();
                                    typeof window !== "undefined" &&
                                      localStorage.setItem("redirectUrl", window.location.href);
                                    navigate("/members/login");
                                  }}
                                >
                                  <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                      d="M12.5 2.5H15.8333C16.2754 2.5 16.6993 2.67559 17.0118 2.98816C17.3244 3.30072 17.5 3.72464 17.5 4.16667V15.8333C17.5 16.2754 17.3244 16.6993 17.0118 17.0118C16.6993 17.3244 16.2754 17.5 15.8333 17.5H12.5"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                    <path
                                      d="M8.33337 14.1666L12.5 9.99998L8.33337 5.83331"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                    <path
                                      d="M12.5 10H2.5"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                  </svg>
                                  Login
                                </a>
                              </li>
                            </ul>
                          )}
                        </>
                      )}
                    </div>
                    {/* <UpcomingDropDown allUpcomingBidDropDown={this.props.allUpcomingBidDropDown} /> */}

                    {typeof window !== "undefined" && window.localStorage.getItem("token") ? (
                      <a
                        href="javascript:void(0)"
                        onClick={() => {
                          if (this.props?.page === "Post Listing" && this.props?.step == 4) {
                            this.props?.setStep(1);
                          } else {
                            navigate("/members/post-listing");
                          }
                        }}
                        className={`${styles.headerBtn} header-btn d-none d-xl-block ms-auto`}
                      >
                        <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M10.0002 4.16669V15.8334"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M4.16687 10H15.8335"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        Post a Listing
                      </a>
                    ) : (
                      <a
                        href="#"
                        className={`${styles.headerBtn} header-btn d-none d-xl-block`}
                        onClick={(e) => {
                          e.preventDefault();
                          typeof window !== "undefined" &&
                            window.localStorage.setItem("redirectUrl", "/members/post-listing");
                          navigate("/members/login");
                        }}
                      >
                        <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M10.0002 4.16669V15.8334"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M4.16687 10H15.8335"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        Post a Listing
                      </a>
                    )}
                  </div>
                </div>
              </div>
            </nav>
          </div>{" "}
        </header>
        <div
          class={`${styles.mobFilterBtnGroup} mob-filter-btn-group mob-filter-btn-group-new ${styles.mobFilterBtnGroupNew} d-md-none d-flex align-items-center`}
        >
          <a
            href="javascript:void(0)"
            className={`filter-btn d-flex align-items-center justify-content-center`}
            data-bs-toggle="modal"
            data-bs-target="#browseCollapse"
            onClick={this.toggleMobileFilter1}
          >
            <p>Browse</p>
          </a>
          {typeof window !== "undefined" && window.localStorage.getItem("token") ? (
            <Link
              to="/members/post-listing"
              className={`${styles.postListing} post-listing d-flex align-items-center justify-content-center`}
            >
              + Post a Listing
            </Link>
          ) : (
            <a
              onClick={(e) => {
                e.preventDefault();
                typeof window !== "undefined" && localStorage.setItem("redirectUrl", "/members/post-listing");
                navigate("/members/login");
              }}
              href="javascript:void(0)"
              className={`${styles.postListing} post-listing d-flex align-items-center justify-content-center`}
            >
              + Post a Listing
            </a>
          )}
        </div>
        {this.props.search !== "not-needed" && (
          <div class={`${styles.fullWidthSearchRow} full-width-search-row static-header-search-row `}>
            <div class={`container-fluid ${styles.containerFluid}`}>
              <div class="row">
                <div class="col-md-12">
                  <div class="flex-grow-1 dropdown position-relative">
                    <div
                      class={`${styles.fwsSearchBox} fws-search-box  position-relative w-100 d-flex align-items-center dropdown-toggle`}
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g opacity="0.6">
                          <path
                            d="M9.16667 15.8333C12.8486 15.8333 15.8333 12.8486 15.8333 9.16667C15.8333 5.48477 12.8486 2.5 9.16667 2.5C5.48477 2.5 2.5 5.48477 2.5 9.16667C2.5 12.8486 5.48477 15.8333 9.16667 15.8333Z"
                            stroke="black"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M17.5 17.5L13.875 13.875"
                            stroke="black"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </g>
                      </svg>
                      <input
                        type="text"
                        className={`${styles.fwsSearchInput} fws-search-input w-100`}
                        placeholder="Search Commercial Products for Sales"
                        value={this.props.page == "search" ? this.props.queryData : this.state.queryData}
                        onKeyDown={(k) => {
                          if (k.key === "Enter" && this.props.page != "search") {
                            navigate(`/search/?q=${this.state.queryData}`);
                            this.setState({ showSearch: false });
                          } else if (k.key === "Enter") {
                            navigate(`/search/?q=${this.props.queryData}`);
                            this.setState({ showSearch: false });
                          }
                        }}
                        onChange={this.onChangeInput}
                      />
                    </div>
                    <div
                      ref={this.dropDownRef}
                      className={
                        this.state.showSearch
                          ? `dropdown-menu ${styles.fullWidthDropdownMenu} full-width-dropdown-menu dropdown-menu-end show`
                          : "dropdown-menu full-width-dropdown-menu dropdown-menu-end"
                      }
                      data-bs-popper="none"
                    >
                      <div className={`${styles.fwdmHead} fwdm-head d-flex align-items-center justify-content-between`}>
                        <h3>{this.props.page == "search" ? this.props.queryData : this.state.queryData}</h3>
                        {this.props.page !== "aviation" ? (
                          <h3
                            className="aviation-parts-search"
                            onClick={() => {
                              this.setState({ showSearch: false });
                              navigate(`/aviation-parts/?filter=${this.state.queryData}`);
                            }}
                          >
                            Search "{this.state.queryData}" in Aviation Parts
                          </h3>
                        ) : (
                          ""
                        )}
                      </div>
                      <div className={`${styles.fwdmBody} fwdm-body`} data-simplebar>
                        <div className={`${styles.fwdmInnerContent} fwdm-inner-content d-flex flex-wrap`}>
                          {this.state.facets["categories.lvl0"] && (
                            <div className={` fwdm-box`}>
                              <h4>Search in Category</h4>
                              <ul>
                                {Object.keys(this.state.facets["categories.lvl0"]).map((ecat) => (
                                  <li>
                                    <a
                                      href="javascript:void(0)"
                                      onClick={(e) => {
                                        e.preventDefault();

                                        ecat == "Pipe"
                                          ? navigate(
                                              `/pipe/?q=${
                                                this.props.page == "search"
                                                  ? this.props.queryData
                                                  : this.state.queryData
                                              }`,
                                            )
                                          : navigate(
                                              `/search/?category=${ecat}&q=${
                                                this.props.page == "search"
                                                  ? this.props.queryData
                                                  : this.state.queryData
                                              }`,
                                            );
                                        this.setState({ showSearch: false });
                                      }}
                                    >
                                      {ecat?.split("_")[0]} ({this.state.facets["categories.lvl0"][ecat]})
                                    </a>
                                  </li>
                                ))}
                              </ul>
                            </div>
                          )}
                          {this.state.facets["region"] && (
                            <div className={`fwdm-box`}>
                              <h4>Search in Region</h4>
                              <ul>
                                {Object.keys(this.state.facets["region"]).map((ecat) => (
                                  <li>
                                    <a
                                      href="javascript:void(0)"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        navigate(
                                          `/search/?region=${ecat}&q=${
                                            this.props.page == "search" ? this.props.queryData : this.state.queryData
                                          }`,
                                        );
                                        this.setState({ showSearch: false });
                                      }}
                                    >
                                      {ecat} ({this.state.facets["region"][ecat]})
                                    </a>
                                  </li>
                                ))}
                              </ul>
                            </div>
                          )}

                          {this.state.facets["make"] && (
                            <div className={` fwdm-box`}>
                              <h4>Search in Manufacturer</h4>
                              <ul>
                                {Object.keys(this.state.facets["make"]).map(
                                  (ecat) =>
                                    this.state?.allManufacturers?.find((ec) =>
                                      ec?.subManufacturers?.find((em) => em.description === ecat),
                                    ) && (
                                      <li>
                                        <a
                                          href="javascript:void(0)"
                                          onClick={(e) => {
                                            e.preventDefault();
                                            navigate(
                                              `/search/?mfr=${ecat}&q=${
                                                this.props.page == "search"
                                                  ? this.props.queryData
                                                  : this.state.queryData
                                              }`,
                                            );
                                            this.setState({ showSearch: false });
                                          }}
                                        >
                                          {ecat} ({this.state.facets["make"][ecat]})
                                        </a>
                                      </li>
                                    ),
                                )}
                              </ul>
                            </div>
                          )}
                        </div>
                      </div>
                      <div className={`${styles.fwdmFooter} fwdm-footer`}>
                        <a
                          href="javascript:void(0)"
                          className={`${styles.btn} btn btn-default `}
                          onClick={() => this.setState({ showSearch: false })}
                        >
                          Close
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {typeof window !== "undefined" && <ScrollButton />}
        {this.state.showMobileFilter && (
          <MobileDropdown
            showModal={this.state.showMobileFilter}
            toggleModal={this.toggleMobileFilter}
            data={this.state.data}
          />
        )}
        {this.state.showMobileFilter1 && (
          <MobileDropdown1
            showModal={this.state.showMobileFilter1}
            toggleModal={this.toggleMobileFilter1}
            data={this.state.data}
          />
        )}
        {this.state.showDashboardSidebarMobile && (
          <NewDashboardSidebarMobile
            showModal={this.state.showDashboardSidebarMobile}
            toggleModal={this.toggleDashboardSidebarModal}
            // page={this.props.page}
            // setStep={this.props.setStep}
            // location={this.props.location}
          />
        )}
        <Modal
          show={this.state.modal}
          onHide={this.toggleModal}
          animation={true}
          className={
            this.state.modal
              ? `modal right-collapse fade modal-lg ${styles.offcanvasPannelContainer} show`
              : `modal right-collapse fade modal-lg ${styles.offcanvasPannelContainer}`
          }
        >
          <div className={`${styles.pannelHeader} d-flex align-items-center"`}>
            <div className={` position-absolute d-block d-md-none`} data-bs-dismiss="modal" onClick={this.toggleModal}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M15 18L9 12L15 6"
                  stroke="black"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
              </svg>
            </div>
            <h4>Notifications</h4>
            <div
              onClick={this.toggleModal}
              className={`${styles.btnClose} btn-close ms-auto d-none d-md-block`}
              data-bs-dismiss="modal"
            ></div>
          </div>
          <div className={styles.pannelBody} data-simplebar>
            <div className={`messageBlock`}>
              {this.state.notifications.map((notification) => (
                <div className={`${styles.messageBlockItem} d-flex flex-wrap align-items-center`}>
                  <div className={styles.mbImgBox}>
                    <img src={notification.primary_image + "_mp.jpg"} alt="notification" />
                  </div>
                  <div
                    className={styles.mbTextBox}
                    style={{ cursor: "pointer" }}
                    onClick={() => this.readNotification(notification.id)}
                  >
                    <h5>
                      {notification.notification_type == "1"
                        ? "New Listing"
                        : notification.notification_type == "2"
                        ? "You've been outbid"
                        : notification.notification_type == "3"
                        ? "Your bid has been sent"
                        : notification.notification_type == "4"
                        ? "Your bid has been accepted"
                        : notification.notification_type == "5"
                        ? "Your bid has been declined"
                        : notification.notification_type == "6"
                        ? "You have received an invoice for your accepted bid"
                        : "New listing"}
                      ({notification.viewed ? "Read" : "Unread"})
                    </h5>
                    <p style={{ maxWidth: "90%" }}>
                      {" "}
                      <p>{notification.title}</p>
                    </p>
                  </div>
                  <div className={`${styles.notifyBox} text-center`}>
                    <div className={styles.mbMonthBox}>{moment(notification.date_created).format("MMMM Do")}</div>
                    <div className={styles.mbTimeBox}>{moment(notification.date_created).format("HH:mm")} </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className={styles.pannelFooter}>
            <a
              href="javascript:void(0)"
              onClick={(e) => {
                e.preventDefault();
                navigate("/my-account", {
                  state: { from: "notification" },
                });
                this.toggleModal();
              }}
              className={styles.pannelBtnLink}
            >
              View all Notifications
            </a>
          </div>
        </Modal>
      </React.Fragment>
    );
  }
}

export default Header;
const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
  <a
    className="dropdown-toggle"
    type="button"
    id="menu"
    data-bs-toggle="dropdown"
    aria-expanded="false"
    href=""
    ref={ref}
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}
  >
    {children}
  </a>
));
